export default __webpack_public_path__ + "static/Investigacion-5df3d8e2f12b622eec09f358b34e6090.png";